// TicketService barrel — endpoint definitions live in @trackly/shared (createTicketApi);
// this instantiates the single web-authenticated instance and re-exports its hooks so existing
// importers across Trackly.WebClient are unaffected by the shared-package extraction.
import { ticketApi } from './ticketApiBase';

export { ticketApi };
export const {
  useGetTicketByIdQuery,
  useLazyGetTicketByIdQuery,
  useGetTicketsCreatedByQuery,
  useGetTicketsAssignedToQuery,
  useGetTicketsPendingCustomerQuery,
  useGetTicketsAssignedToUserTeamsQuery,
  useListDocumentsQuery,
  useViewDocumentQuery,
  useUpsertTicketMutation,
  useUploadDocumentMutation,
  useDownloadDocumentMutation,
  useDeleteDocumentMutation,
} = ticketApi;
export { createDefaultTicket } from './createDefaultTicket';
export type {
  TicketIdentificationView,
  TicketPriorityInfoView,
  TicketAssignmentView,
  TicketWorkflowView,
  TicketTimeTrackingView,
  TicketCommunicationView,
  TicketCustomerInfoView,
  TicketCommentView,
  HstRoleView,
  JobTitleView,
  ResolutionAttemptView,
  TicketResolutionView,
  TicketView,
  TicketWorklistView,
  DocumentView,
  UploadDocumentRequest,
  ListDocumentsRequest,
  DownloadDocumentRequest,
  ViewDocumentRequest,
  DeleteDocumentRequest,
  DocumentUploadResponse,
  DocumentListResponse,
  DocumentError,
  TicketGetByIdParams,
  TicketsCreatedByRequest,
  TicketsAssignedToRequest,
  TicketsPendingCustomerRequest,
  TicketsAssignedToUserTeamsRequest,
  TicketUpsertRequest,
  TicketFieldConflict,
  TicketConflictError,
} from '@trackly/shared';
